import { MTextField, ResponsiveFormContainer } from "@app/components";
import { MODES_OPTIONS } from "@app/types/generics.types";
import { Grid, Typography } from "@mui/material";

interface PotasioAAFormProps {
  mode: MODES_OPTIONS;
}

const PotasioAAForm = ({ mode }: PotasioAAFormProps) => {
  const isView = mode === MODES_OPTIONS.VIEW;

  return (
    <>
      <Grid item xs={12} my={3} mt={3}>
        <Typography variant="tagText">
          {"% Incert. del volumen muestra para k=2 (%)"}
        </Typography>
      </Grid>

      <ResponsiveFormContainer columns={2}>
        <MTextField
          name="volume_water_1ml_k1_g_2"
          label="Si 0.05mg/l ≤ x ≤ 0.299mg/l"
          type="number"
          fullWidth
          validation={{ required: "El valor es requerido" }}
          disabled={isView}
        />
        <MTextField
          name="volume_water_5ml_k1_g_2"
          label="Si 0.300mg/l ≤ x ≤ 0.999mg/l"
          type="number"
          fullWidth
          validation={{ required: "El valor es requerido" }}
          disabled={isView}
        />
        <MTextField
          name="volume_water_25ml_k1_g_2"
          label="Si x ≥ 1.00mg/l"
          type="number"
          fullWidth
          validation={{ required: "El valor es requerido" }}
          disabled={isView}
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default PotasioAAForm;
